export const carsType = [
 {name : "Berline"          , image : "voiture_type/Berline.svg"          , hoverImage : "voiture_type/Berline-B.svg"        , key : "Berline"        , english: "SEDAN"},
 {name : "Familiale"        , image : "voiture_type/Familiale.svg"        , hoverImage : "voiture_type/Familiale-B.svg"      , key : "Familiale"      , english: "ESTATE"},
 {name : "Fourgonnette"     , image : "voiture_type/Fourgonnette.svg"     , hoverImage : "voiture_type/Fourgonnette-B.svg"   , key : "Fourgonnette"   , english: "VAN"},
 {name : "Cabriolet"        , image : "voiture_type/Cabriolet.svg"        , hoverImage : "voiture_type/Cabriolet-B.svg"      , key : "Cabriolet"      , english: "CONVERTIBLE"},
 {name : "Sport"            , image : "voiture_type/Sport.svg"            , hoverImage : "voiture_type/Sport-B.svg"          , key : "Sport"          , english: "SPORTSCAR"},
 {name : "Camionnette"      , image : "voiture_type/Camionnette.svg"      , hoverImage : "voiture_type/Camionnette-B.svg"    , key : "Camionnette"    , english: "PICKUP"},
 {name : "4x4-SUV"          , image : "voiture_type/SUV-4x4.svg"          , hoverImage : "voiture_type/SUV-4x4-B.svg"        , key : "SUV"            , english: "SUV"},
 {name : "À hayon"          , image : "voiture_type/Hayon.svg"            , hoverImage : "voiture_type/Hayon-B.svg"          , key : "hayon"          , english: "HATCHBACK"},
//  {name : "Autres"           , image : "Autres"           , key : "Autres"         }
];
export const fuelType = [
  { name: "Essence", english: "Gasoline" },
  { name: "Diesel", english: "Diesel" },
  { name: "Electrique", english: "Electric" },
  { name: "Hybrid", english: "Hybrid" }
];

export const transmissions = [
  { name: "Automatique", english: "Automatic" },
  { name: "Manuel", english: "Manual" }
];

export const marksLogo = [
  { name: "Audi", key: "Audi" ,               url : '~/assets/images/error/404-TopAuto.svg'},
  { name: "Chevrolet", key: "Chevrolet" ,     url : '~/assets/images/Logo-Marque-Topauto/Chevrolet.svg'},
  { name: "Ford", key: "Ford" ,               url : '~/assets/images/Logo-Marque-Topauto/Ford.svg'},
  { name: "Mazda", key: "Mazda" ,             url : '~/assets/images/Logo-Marque-Topauto/Mazda.svg'},
  { name: "Mercedes", key: "Mercedes-Benz" ,  url : '~/assets/images/Logo-Marque-Topauto/Mercedes.svg'},
  { name: "Renault", key: "Renault" ,         url : '~/assets/images/Logo-Marque-Topauto/Renault.svg'},
  { name: "Volkswagen", key: "Volkswagen",    url : '~/assets/images/Logo-Marque-Topauto/Volkswagen.svg'},
];
